<template>
  <div ref="root" style="width: 100%; overflow: auto; margin-bottom: 1rem">
    <div
      v-observe-visibility="{
        callback: onVisible,
        intersection: {
          rootMargin: '400px',
          threshold: 0.125
        }
      }"
      class="context has-background-white-ter"
      :style="{
        display: 'block',
        width: `${screenWidth}px`,
        height: `${screenHeight}px`
      }"
    >
    
      <img
        v-if="source !== null"
        :src="source"
        :style="{
          display: 'block',
          width: '100%',
          height: `${screenHeight}px`
        }"
        @error="onError"
      >
      <Highlight
        v-for="(item,index) in results"
        :key="index"
        v-bind="item"
        :is-primary="true"
      />
    </div>
  </div>
</template>

<style>
.context {
  position: relative;
  width: 100%;
  overflow: hidden;
  /* box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.175); */
}
</style>

<script>
 import imageMixin from '@/mixins/image.js'
 import Highlight from '@/components/Highlight.vue'

 export default {
   components: { Highlight },
   mixins: [imageMixin],
   props: {
     items: Array,
     croppedRect: Object,
     image: Object,
   },
   data: () => ({
     screenWidth: null,
     isReady: false,
     isVisible: false,
     isError: false
   }),
   computed: {
     screenHeight() {
       return Math.round(
         this.rect.height * (this.screenWidth / this.rect.width)
       )
     },
     rect() {
       const { width, height } = this.image
       const { rect } = this.items[0]

       const isDoublePage = width / height > 1
       const x = !isDoublePage ? 0 : rect.x < width / 2 ? 0 : width / 2

       return this.getRoundedRect({
         x: x,
         y: this.croppedRect.y,
         width: !isDoublePage ? width  : width / 2,
         height: this.croppedRect.height +50
       })
     },
     results() {
       return this
	 .items
	 .map(item => ({
	   ...item,
	   rect: this.getPaddedRect(item.rect, 0.5 * item.rect.height)
	 }))
	 .map(item => ({
	   ...item,
	   rect: this.getRoundedRect(
	     this.getRelativeRect(item.rect)
	   )
	 }))
     },
     source() {
       if (this.isError) return null
       if (!this.isVisible) return null
       return this.getContextImageSource(this.image.id, this.rect, {
         width: this.screenWidth,
         height: this.screenHeight
       })
     }
   },
   mounted() {
     // this.screenWidth = console.log(this.$parent.$el.offsetWidth)
     window.addEventListener('resize', this.update)
     this.$nextTick(this.update)
   },
   destroyed() {
     window.removeEventListener('resize', this.update)
   },
   methods: {
     onVisible(isVisible, entry) {
       if (this.isVisible) return
       if (isVisible) this.isVisible = isVisible
     },
     onError() {
       this.isError = true
     },
     update() {
       const root = this.$refs.root
       if (!root) return console.error('failed to get container width')
       if (!root.offsetWidth) return
       if (root.offsetWidth === 0)
	 return console.error('container width must not be 0')
       
       this.screenWidth = root.offsetWidth
       this.isReady = true
     },
     getRelativeRect({ x, y, width, height }) {
       return {
	 x: (100 * (x - this.rect.x)) / this.rect.width,
	 y: (100 * (y - this.rect.y)) / this.rect.height,
	 width: (100 * width) / this.rect.width,
	 height: (100 * height) / this.rect.height
       }
     }
   }
 }
</script>
